// uses ./AppDomainSettings.less
import PropTypes from 'prop-types';
import React from 'react';
import pick from 'lodash/pick';
import EGNYTE_PLATFORM from '@integrations/pint-appstore-commons/src/enums/EGNYTE_PLATFORM.json';
import getOpenSettings from '../../appSettings/AppSettingsHelper';
import AppDomainSettingsActionBoxEdit from './appDomainSettingsActionBox/AppDomainSettingsActionBoxEdit';
import AppDomainSettingsActionBoxConfigure from './appDomainSettingsActionBox/AppDomainSettingsActionBoxConfigure';

// it's a component on AppStatusForm component (or rather AdminSettingsModal)
// TODO rename it to AppGlobalConfiguration or GlobalConfigurationInitiator
function AppDomainSettings(props) {
    const openSettings = getOpenSettings(
        pick(props, [
            'settingsURL',
            'token',
            'saveUrl',
            'confirmUrl',
            'setupUpdateUrl',
            'domain',
            'appId',
            'dispatchFetchStatusForm',
            'isConfigured',
            'domainSettingsRequired',
        ]),
        { enableAppConfigurationUpdates: true }
    );
    const { isConfigured, domainSettingsRequired, appId, domainSettingsEnabledFromFeatureFlag } = props;
    const GDRIVE_APP_ID = 'gdocs';

    const isGoogleDocs = appId === GDRIVE_APP_ID;
    const shouldShowEditConfigurationOption =
        domainSettingsRequired &&
        (isConfigured[EGNYTE_PLATFORM.COLLABORATE] ||
            isConfigured[EGNYTE_PLATFORM.SECURE_AND_GOVERN] ||
            (isGoogleDocs && isConfigured[EGNYTE_PLATFORM.COLLABORATE]));
    const getMarkup = ({ openSettings, isGoogleDocs, domainSettingsEnabledFromFeatureFlag }) => {
        if (shouldShowEditConfigurationOption) {
            if (isGoogleDocs) {
                if (domainSettingsEnabledFromFeatureFlag)
                    return <AppDomainSettingsActionBoxEdit openSettings={openSettings} />;

                return null;
            }

            return <AppDomainSettingsActionBoxEdit openSettings={openSettings} />;
        }
        if (isGoogleDocs) {
            if (!domainSettingsEnabledFromFeatureFlag) return null;

            return <AppDomainSettingsActionBoxEdit openSettings={openSettings} />;
        }

        return (
            <AppDomainSettingsActionBoxConfigure
                openSettings={openSettings}
                userManual={props.userManual}
                onClickLink={props.onClickLink}
            />
        );
    };

    return (
        <div className="ast-app-configuration">
            {getMarkup({
                openSettings,
                isGoogleDocs,
                domainSettingsEnabledFromFeatureFlag,
            })}
        </div>
    );
}

AppDomainSettings.propTypes = {
    appId: PropTypes.string.isRequired,
    settingsURL: PropTypes.string.isRequired,
    token: PropTypes.string,
    saveUrl: PropTypes.string,
    domain: PropTypes.string,
    userManual: PropTypes.string,
    onClickLink: PropTypes.func.isRequired,
    isConfigured: PropTypes.object.isRequired,
    domainSettingsRequired: PropTypes.bool,
    dispatchFetchStatusForm: PropTypes.func.isRequired,
    domainSettingsEnabledFromFeatureFlag: PropTypes.bool,
};

export default AppDomainSettings;
